import HomePageSearchRequest from "@/models/HomePageSearchRequest";
import FormatCurrency from "../formatters/FormatCurrency";
import { RangeAspect } from "@/models/HomePageSearchResponse";

function* GetBasicParts(
  searchRequest: HomePageSearchRequest
): Generator<string> {
  if (searchRequest.searchQuery) {
    yield searchRequest.searchQuery;
  }
  if (searchRequest.colours.length === 1) {
    yield searchRequest.colours[0].label;
  }
  if (searchRequest.breeds.length === 1) {
    yield searchRequest.breeds[0].label;
  }
  if (searchRequest.disciplines.length === 1) {
    yield searchRequest.disciplines[0].label;
  }
  if (searchRequest.riderLevels.length === 1) {
    yield searchRequest.riderLevels[0].label;
  }
}

function* GetNounParts(
  searchRequest: HomePageSearchRequest
): Generator<string> {
  if (searchRequest.genders.length === 1) {
    yield searchRequest.genders[0].label + "s";
  } else if (searchRequest.categories.length === 1) {
    yield searchRequest.categories[0].label;
  } else if (searchRequest.vertical) {
    yield searchRequest.vertical.label;
  } else {
    yield "Everything Equine";
  }
}

function* GetRangeParts(
  range: RangeAspect,
  suffix: string,
  formatter: (value: number) => string
): Generator<string> {
  if (range.min !== -1 || range.max !== -1) {
    if (range.min === -1) {
      yield `under ${formatter(range.max)} ${suffix}`;
    } else if (range.max === -1) {
      yield `over ${formatter(range.min)} ${suffix}`;
    } else {
      yield `between ${formatter(range.min)} & ${formatter(range.max)} ${suffix}`;
    }
  }
}

function* GetSuffixParts(
  searchRequest: HomePageSearchRequest
): Generator<string> {
  if (searchRequest.vertical?.id === "197") {
    yield "stallions at stud";
  } else {
    yield "for sale";
  }

  if (searchRequest.locations.length > 0) {
    yield "in " + searchRequest.locations[0].label;
  }

  if (searchRequest.isUrgent) {
    yield "urgently";
  }
}

function* GetMainParts(
  searchRequest: HomePageSearchRequest
): Generator<string> {
  yield* GetBasicParts(searchRequest);
  yield* GetNounParts(searchRequest);
  yield* GetRangeParts(searchRequest.price, "", FormatCurrency);
  yield* GetRangeParts(searchRequest.age, "years old", (x) => x.toString());
  yield* GetRangeParts(searchRequest.height, "hands high", (x) => x.toString());
}

export function GetPageTitle(searchRequest: HomePageSearchRequest): string {
  return [
    ...[...GetMainParts(searchRequest)].map((x) => x.toLowerCase()),
    ...GetSuffixParts(searchRequest),
  ]
    .map((x) => x.trim())
    .join(" ")
    .trim()
    .replace(/^\w/, (c) => c.toUpperCase());
}
